import { useEffect } from "react";

/**
 * Set a dynamic browser tab title for the current page.
 *
 *   usePageTitle("Recruitment");           // → "Recruitment — SkillConnect"
 *   usePageTitle("Hiring Dashboard", "Co"); // → "Hiring Dashboard — Co"
 *
 * Restores the previous title on unmount so going back to the landing
 * page reverts to the SEO-tuned default in index.html.
 */
export default function usePageTitle(title, suffix = "SkillConnect") {
  useEffect(() => {
    const prev = document.title;
    if (title) {
      document.title = `${title} — ${suffix}`;
    }
    return () => { document.title = prev; };
  }, [title, suffix]);
}
